import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexWrap: 'nowrap',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: '100%',
    margin: '1rem 0',
    boxShadow: 'none',
    border: 'none',
  },
  image: {
    height: '9rem',
    width: '9rem',
    borderRadius: '50%',
  },
  description: {
    paddingTop: '0.5rem',
  },
});

const PersonCard = ({name, position, description, image}) => {
  const classes = useStyles();
  return (
    <Card className={classes.root}>
      <CardMedia
        className={classes.image}
        component="img"
        src={image}
      />
      <CardContent className={classes.content}>
        <Typography variant="h3" color="primary">
          {name}
        </Typography>
        <Typography variant="subtitle2">
          {position}
        </Typography>
        <Typography variant="body2" className={classes.description}>
          {description}
        </Typography>
      </CardContent>
    </Card>
  );
};

PersonCard.propTypes = {
  name: PropTypes.string.isRequired,
  position: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
};

export default PersonCard;
